module.exports = __webpack_public_path__ + "img/bg.8fcc6d7e.png";